// Module
var code = "<div id=\"V-84D51DFD-1D11-40F4-B197-22DFC7BC60B6\"> <div data-b-component=\"input\" class=\"input\" data-b-comp-text=\"{Binding value}\"></div> </div> ";
// Exports
export default code;